
let Observer = null

const callback = function(mutationsList, observer){
            for(var mutation of mutationsList) {
                    if (mutation.type == 'childList') {
                        let closeButton = document.getElementById('jsd-widget').contentWindow.document.getElementsByClassName('close-icon')
                        for (let item of closeButton) {
                                item.addEventListener('click', function() {
                                document.getElementById('jsd-widget').style.display = 'none'
                                Observer.disconnect()
                                }) 
                            }   
                    }
                }
    }


const HelpDeskObserver = {

        startObserver() {
            var targetNode = document.getElementById('jsd-widget').contentWindow.document.getElementById("react-root")
			var config = { attributes: true, childList: true, subtree: true };
            Observer = new MutationObserver(callback);
            Observer.observe(targetNode, config);
        },
    }


export default HelpDeskObserver
